


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Autocomplete, TextField,
} from '@mui/material';
import axios from 'axios';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';

export const MasterAssetComponent = () => {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [feOptions, setFeOptions] = useState([]);
  const [selectedFE, setSelectedFE] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const renderLinkCell = (url) => (url && url !== '-' ? (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
    >
      View
    </a>
  ) : <span>-</span>);

  const columns = [
    { field: 'slNo', headerName: 'Sl. No', width: 70 },

    { field: 'fe_name_of_fe', headerName: 'Financial Establishment', width: 250 },
    { field: 'fe_name_of_ca', headerName: 'Competent Authority', width: 220 },
    { field: 'fe_designation', headerName: 'Designation', width: 300 },
    { field: 'fe_phone', headerName: 'Phone Number', width: 140 },
    { field: 'fe_email', headerName: 'Email', width: 200 },

    { field: 'fir_no', headerName: 'FIR No', width: 150 },
    { field: 'fir_date', headerName: 'FIR Date', width: 130 },
    { field: 'police_station', headerName: 'Police Station', width: 180 },
    { field: 'property_seized_date', headerName: 'Property Seized Date', width: 160 },

    {
      field: 'notification',
      headerName: 'Notification',
      width: 200,
      renderCell: (params) => renderLinkCell(params.value),
    },
    { field: 'notification_date', headerName: 'Notification Date', width: 130 },
    { field: 'notification_no', headerName: 'Notification No', width: 150 },

    { field: 'property_detals', headerName: 'Property Details', width: 220 },
    { field: 'survey_no', headerName: 'Survey No', width: 130 },
    { field: 'property_type', headerName: 'Property Type', width: 170 },
    { field: 'type_of_asset', headerName: 'Type of Asset', width: 170 },
    { field: 'hobli', headerName: 'Hobli', width: 130 },
    { field: 'village', headerName: 'Village', width: 130 },
    { field: 'taluk', headerName: 'Taluk', width: 130 },
    { field: 'district', headerName: 'District', width: 130 },
    { field: 'state', headerName: 'State', width: 130 },
    { field: 'pincode', headerName: 'Pincode', width: 110 },
    {
      field: 'geo_location',
      headerName: 'Geo Location',
      width: 220,
      renderCell: (params) => renderLinkCell(params.value),
    },

    { field: 'asset_5_2_misc', headerName: 'Asset 5(2) Misc', width: 150 },
    {
      field: 'asset_5_2_court_order',
      headerName: 'Court Order',
      width: 250,
      renderCell: (params) => renderLinkCell(params.value),
    },
     {
      id: 'orderDate',
      field: 'orderDate',
      headerName: '5(2) Order Date',
      width: 150,
    },
    { field: 'asset_5_2_result', headerName: 'Result', width: 250 },
    { field: 'asset_5_2_appeals', headerName: 'Appeals', width: 250 },

    { field: 'valuation_agency', headerName: 'Valuation Agency', width: 200 },
    { field: 'valuation_work_ord_date', headerName: 'Work Order Date', width: 140 },
    { field: 'valuation_report_date', headerName: 'Report Date', width: 140 },
    { field: 'valuation_status', headerName: 'Valuation Status', width: 140 },
    { field: 'area', headerName: 'Area', width: 120 },
    { field: 'guideline_value', headerName: 'Guideline Value', width: 150 },
    { field: 'building_value', headerName: 'Building Value', width: 150 },
    { field: 'total_value', headerName: 'Total Value', width: 150 },
    {
      field: 'valuation_report',
      headerName: 'Valuation Report',
      width: 250,
      renderCell: (params) => renderLinkCell(params.value),
    },

    { field: 'khata_holder', headerName: 'Khata Holder', width: 200 },
    { field: 'date_of_auction', headerName: 'Date of Auction', width: 140 },
    { field: 'final_bid_amt', headerName: 'Final Bid Amount', width: 150 },
    { field: 'success_bid_amt', headerName: 'Success Bid Amount', width: 150 },
    { field: 'gst', headerName: 'GST', width: 100 },
    { field: 'tcs', headerName: 'TCS', width: 100 },
    { field: 'total', headerName: 'Total', width: 120 },
    { field: 'success_bidder_name', headerName: 'Success Bidder Name', width: 200 },
    { field: 'auction_amt', headerName: 'Auction Amount', width: 150 },
    { field: 'realized_amt', headerName: 'Realized Amount', width: 150 },

    { field: 'sec8_status', headerName: 'Sec8 Status', width: 150 },
    {
      field: 'sec8_doc',
      headerName: 'Sec8 Document',
      width: 250,
      renderCell: (params) => renderLinkCell(params.value),
    },
    { field: 'sec8_final_remark', headerName: 'Sec8 Final Remark', width: 250 },
  ];

  React.useEffect(() => {
    axios.get(`${API_BASE_URL}/asset-mgmt/asset-master/`)
      .then(({ data }) => {
        const firMap = {};
        data.fir_master.forEach(fir => { firMap[fir.id] = fir; });

        const apiData = data.property_master.map((item, index) => {
          const fe = item.asset3_2_base?.fe || {};
          const asset3_2 = item.asset3_2_base || {};
          const asset_5_2 = item.asset_5_2_fe?.[0] || {};
          const asset_valuation = item.asset_valuation_fe?.[0] || {};
          const asset_auction = item.asset_auction_fe?.[0] || {};
          const asset_sec8 = item.asset_sec_8_fe?.[0] || {};
          const fir = firMap[item.id] || {};

          return {
            id: item.id || index,
            slNo: index + 1,
            fe_name_of_fe: fe.name_of_fe || '-',
            fe_name_of_ca: fe.name_of_ca || '-',
            fe_designation: fe.designation || '-',
            fe_phone: fe.ph_number || '-',
            fe_email: fe.email || '-',
            fir_no: fir.fir_no || '-',
            fir_date: fir.fir_date ? new Date(fir.fir_date).toLocaleDateString('en-GB') : '-',
            police_station: fir.police_station || '-',
            property_seized_date: fir.property_seized_date ? new Date(fir.property_seized_date).toLocaleDateString('en-GB') : '-',
            notification: asset3_2.notification|| '-',
            notification_date: asset3_2.date ? new Date(asset3_2.date).toLocaleDateString('en-GB') : '-',
            notification_no: asset3_2.notification_no || '-',
            property_detals: item.property_detals || '-',
            survey_no: item.survey_no || '-',
            property_type: item.property_type || '-',
            type_of_asset: item.type_of_asset || '-',
            hobli: item.hobli || '-',
            village: item.village || '-',
            taluk: item.taluk || '-',
            district: item.district || '-',
            state: item.state || '-',
            pincode: item.pincode || '-',
            geo_location: item.geo_location_link || item.geo_location || '-',
            asset_5_2_misc: asset_5_2.misc || '-',
            asset_5_2_court_order: asset_5_2.court_order_link || asset_5_2.court_order || '-',
            asset_5_2_result: asset_5_2.result || '-',
            asset_5_2_appeals: asset_5_2.appeals || '-',
            orderDate: asset_5_2.date || '-',
            valuation_agency: asset_valuation.valuation_agency || '-',
            valuation_work_ord_date: asset_valuation.valuation_work_ord_date ? new Date(asset_valuation.valuation_work_ord_date).toLocaleDateString('en-GB') : '-',
            valuation_report_date: asset_valuation.valuation_report_date ? new Date(asset_valuation.valuation_report_date).toLocaleDateString('en-GB') : '-',
            valuation_status: asset_valuation.valuation_status || '-',
            area: asset_valuation.area || '-',
            guideline_value: asset_valuation.guideline_value || '-',
            building_value: asset_valuation.building_value || '-',
            total_value: asset_valuation.total_value || '-',
            valuation_report: asset_valuation.valuation_report_link || asset_valuation.valuation_report || '-',
            khata_holder: asset_auction.khata_holder || '-',
            date_of_auction: asset_auction.date_of_auction ? new Date(asset_auction.date_of_auction).toLocaleDateString('en-GB') : '-',
            final_bid_amt: asset_auction.final_bid_amt || '-',
            success_bid_amt: asset_auction.success_bid_amt || '-',
            gst: asset_auction.gst || '-',
            tcs: asset_auction.tcs || '-',
            total: asset_auction.total || '-',
            success_bidder_name: asset_auction.success_bidder_name || '-',
            auction_amt: asset_auction.auction_amt || '-',
            realized_amt: asset_auction.realized_amt || '-',
            sec8_status: asset_sec8.status || '-',
            sec8_doc: asset_sec8.doc_link || asset_sec8.doc || '-',
            sec8_final_remark: asset_sec8.Final_remark || '-',
          };
        });

        setRows(apiData);
        setFilteredRows(apiData);

        const feNames = [...new Set(apiData.map(r => r.fe_name_of_fe).filter(name => name !== '-'))];
        setFeOptions(feNames.map(name => ({ label: name, value: name })));

        setSnackbarMessage('Master asset data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch(() => {
        setSnackbarMessage('Failed to load master asset data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, []);

  const handleScrollbarClose = () => setSnackbarOpen(false);

  const handleFEFilterChange = (event, value) => {
    setSelectedFE(value);
    if (value) {
      setFilteredRows(rows.filter(row => row.fe_name_of_fe === value.value));
    } else {
      setFilteredRows(rows);
    }
  };

  if (loading) return <LoadingSpinner size={40} />;

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 4, borderRadius: 2, boxShadow: '0 5px 15px rgba(0,0,0,0.1)', backgroundColor: '#fff' }}>
      <Box sx={{ p: 2 }}>
        <Typography variant="h4" align="center" fontWeight="bold" mb={2}>Master Asset Data</Typography>
        <Autocomplete
          options={feOptions}
          value={selectedFE}
          onChange={handleFEFilterChange}
          clearOnEscape
          sx={{ width: 300, mb: 2 }}
          renderInput={(params) => <TextField {...params} label="Filter by FE Name" variant="outlined" size="small" />}
        />
      </Box>
      <TableComponent
        columns={columns}
        rows={filteredRows}
        manageColumnStatus
        enableSort
        sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold' } }}
      />
      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleScrollbarClose} />
    </Box>
  );
};
